export const metaData = {
  language: "en",
  title: "Podroom Creative - All in one stop shop for your content",
  description: "Podroom Creative is a creative content agency that specialises in content creation and content marketing with a strong emphasis on SEO.",
  keywords: "content, creative, writing, seo, blog, onpage, linkbuilding, smm, social, media",
  image: "/Podroom Creative - All in one stop shop for your content.png"
}